const PT = require("prop-types");
const React = require("react");

const styles = require("./styles/SVGIcon.css");
const colorStyles = require("./styles/Colors.css");

const SVGIcon = function(props) {
	const {
		mainClass,
		svgClass,
		type,
		colorName = "black",
		disabled = false,
		useWonkyCursor = false,
		useColorHoverEffect = false,
	} = props;

	const style = {};
	const mainClasses = [];
	const svgClasses = [styles.svg];
	if (mainClass) mainClasses.push(mainClass);
	if (svgClass) svgClasses.push(svgClass);

	if (!disabled) {
		style.cursor = useWonkyCursor
			? "url(/assets/images/cursors/wonky-hand-point.cur), pointer"
			: "pointer";
		if (useColorHoverEffect) {
			svgClasses.push(colorStyles[colorName + "ColorHoverEffect"]);
			svgClasses.push(styles.arrowHoverEffect);
		}
	}

	svgClasses.push(colorStyles[colorName + "Color"]);

	let icon;
	if (["trainer", "test"].includes(type)) {
		icon = (
			<div className={mainClasses.join(" ")} style={style}>
				<svg
					x="0px"
					y="0px"
					viewBox="0 0 30 30"
					enableBackground="new 0 0 30 30"
					xmlSpace="preserve"
					width="30"
					height="30"
					preserveAspectRatio="none"
					className={svgClasses.join(" ")}
				>
					<g>
						<path d="M8.5,22.9l1.5-2.3c0,0-2.7-8.4,3.9-9.6s5.8,9,5.8,9l1.8,2L8.5,22.9z" />
						<path d="M11.4,22.6c0.1,1.1,1.1,2,2.2,2c1.3,0,2.3-1,2.3-2.2c0,0,0-0.1,0-0.1L11.4,22.6z" />
						<polygon points="25.1,6.3 22.1,6.3 25.3,25.4 6.6,26.5 6.6,6.3 4.5,6.3 4.5,6.9 3.7,29.8 29.5,28.5" />
						<polygon points="1.1,9.9 28,9.9 28,6.3 14.9,0.2 0.5,7.2" />
					</g>
				</svg>
			</div>
		);
	} else if (type === "library") {
		icon = (
			<div className={mainClasses.join(" ")} style={style}>
				<svg
					viewBox="0 0 30 30"
					width="30"
					height="30"
					preserveAspectRatio="none"
					className={svgClasses.join(" ")}
				>
					<g>
						<path d="M28.22,5.45S21.6,1,15,5.35c0,0-1.86-3.24-13.07-1.77,0,0,.68,12.08-.69,21.49,0,0,11.38-2.13,13.76,2.06,0,0,5.21-5.43,13.67-1.07A200.22,200.22,0,0,0,28.22,5.45Zm-23.41,7C9.32,11.81,12,13,13,13.55l0,1.77c-3-1.25-7.54-1-8.1-.93ZM13,7.7l0,1.91a19,19,0,0,0-8.22-.49l0-2.52A20.27,20.27,0,0,1,13,7.7ZM4.54,21.46l.27-3a19.12,19.12,0,0,1,8.06,1l0,2.28C9.66,20.46,6,21.22,4.54,21.46Zm12.82-8a18.69,18.69,0,0,1,8.75-.05l-.07,2a30,30,0,0,0-8.61-.16Zm8.88-6-.07,1.94a23.33,23.33,0,0,0-9-.13l-.06-1.9C20.06,5.89,22.67,6.8,26.24,7.45Zm-8.59,14-.06-1.81A22.11,22.11,0,0,1,25.91,19l-.08,2.38A20.92,20.92,0,0,0,17.65,21.46Z" />
					</g>
				</svg>
			</div>
		);
	} else if (type === "theater-play-selected") {
		icon = (
			<div className={mainClasses.join(" ")} style={style}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 30 30"
					width="30"
					height="30"
					preserveAspectRatio="none"
					className={svgClasses.join(" ")}
				>
					<g>
						<path d="M15,.6967A14.30327,14.30327,0,1,0,29.30331,15C29.30331,7.10048,23.612.6967,15,.6967ZM8.87328,22.21927l-.628-14.34749,16.1817,6.9546Z" />
					</g>
				</svg>
			</div>
		);
	} else if (type === "theater-play") {
		icon = (
			<div className={mainClasses.join(" ")} style={style}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 30 30"
					width="30"
					height="30"
					preserveAspectRatio="none"
					className={svgClasses.join(" ")}
				>
					<g>
						<polygon points="24.427 14.826 8.245 7.872 8.873 22.219 24.427 14.826" />
						<path d="M15.00005.69666A14.30328,14.30328,0,1,0,29.30334,14.99994C29.30334,7.10047,23.61193.69666,15.00005.69666Zm0,25.38012a11.07684,11.07684,0,1,1,0-22.15368A10.73989,10.73989,0,0,1,26.0769,14.99994,11.07682,11.07682,0,0,1,15.00005,26.07678Z" />
					</g>
				</svg>
			</div>
		);
	} else if (type === "learn-more") {
		icon = (
			<div className={mainClasses.join(" ")} style={style}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 30 30"
					width="30"
					height="30"
					preserveAspectRatio="none"
				>
					<g>
						<path d="M23,14.8L9,9L9,21Z" />
						<path d="M15.00005.69666A14.30328,14.30328,0,1,0,29.30334,14.99994C29.30334,7.10047,23.61193.69666,15.00005.69666Zm0,25.38012a11.07684,11.07684,0,1,1,0-22.15368A10.73989,10.73989,0,0,1,26.0769,14.99994,11.07682,11.07682,0,0,1,15.00005,26.07678Z" />
					</g>
				</svg>
			</div>
		);
	} else if (type === "bonus-beast") {
		icon = (
			<div className={mainClasses.join(" ")} style={style}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
					className={svgClasses.join(" ")}
				>
					<g>
						<path d="M35,21.65l-.57-.55a2.23,2.23,0,0,0,.15-.63,3.23,3.23,0,0,0-1.83-2.83c1.49-.32,1.95-1.26,1.74-2.18A10.75,10.75,0,0,0,37.8,7.72,6.6,6.6,0,0,1,33,11a1.14,1.14,0,0,0-.16-.31,3.3,3.3,0,0,0-2.74-1,1.9,1.9,0,0,0,.46-3.11,3.87,3.87,0,0,0-3.84,0c1-3.19-4.27-4.34-5-1.37C21,3.66,19.82,2.56,18,2.84,16,3.2,15.61,4.42,15.8,6.4c-1.5-3.17-6.67-.09-4.11,1.92A2.9,2.9,0,0,0,8.21,9.51a1.89,1.89,0,0,0,.22,2A7.17,7.17,0,0,1,1.5,8.06s-.21,6.23,5.41,9.13c-1.28.74-1.63,2.69-.55,3.53-.31.27-.64.57-1,.93-3.06,3.07-3.55,9.57-3.55,9.57l1.32-1.64,1.28,3.35L5,30.87l1.72,1.86V29.66L8,30.18l-.56-2.59L8.7,25.72a2.56,2.56,0,0,0,1-.33c.06.21.12.4.19.58,0,1.86,1.42,3.21,2.8,2.58l.56,5.65c-.81-.15-3.87-.7-3.32-.06a3,3,0,0,0,1.06.62c-.86.14-1.63.34-1.63.58,0,.54,2.85.24,2.85.24S10,36.82,11,37.16s3.79-1.41,3.79-1.41l4.21,0,.31-5.65a3,3,0,0,0,1.72.43l.27,4.89,4.21,0s2.83,1.76,3.79,1.42S28,35.26,28,35.26s2.84.3,2.85-.24c0-.25-.77-.44-1.63-.59a2.84,2.84,0,0,0,1.06-.61c.55-.64-2.51-.09-3.32.06l.55-5.53a2.08,2.08,0,0,0,2.2-.2A2.33,2.33,0,0,0,30.28,26c.07-.17.14-.36.21-.56a1.74,1.74,0,0,0,1,0l1.44,2.08-.57,2.59,1.3-.52v3.07l1.73-1.86.53,2.06,1.27-3.35,1.33,1.64S38,24.72,35,21.65Z" />
					</g>
				</svg>
			</div>
		);
	}

	return icon;
};

SVGIcon.propTypes = {
	type: PT.oneOf([
		"learn-more",
		"library",
		"trainer",
		"theater-play",
		"theater-play-selected",
		"bonus-beast",
		"test",
	]),
	useColorHoverEffect: PT.bool,
	useWonkyCursor: PT.bool,
	disabled: PT.bool,
	colorName: PT.string,
	mainClass: PT.string, //applied to svg top level html container
	svgClass: PT.string, //applied only to svg content and groups
};

module.exports = SVGIcon;
